var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7987 8.64226H8.85075V13.588C8.85075 14.1321 8.40544 14.5772 7.86117 14.5772C7.31689 14.5772 6.87158 14.1321 6.87158 13.588V8.64226H1.92367C1.37939 8.64226 0.934082 8.19714 0.934082 7.6531C0.934082 7.10906 1.37939 6.66394 1.92367 6.66394H6.87158V1.71816C6.87158 1.17412 7.31689 0.729004 7.86117 0.729004C8.40544 0.729004 8.85075 1.17412 8.85075 1.71816V6.66394H13.7987C14.3429 6.66394 14.7882 7.10906 14.7882 7.6531C14.7882 8.19714 14.3429 8.64226 13.7987 8.64226Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.2fd8118f1ac4f18ed9c4294b86eecd60.svg";
export { ForwardRef as ReactComponent };